import { defineComponent as n, ref as i, watch as l } from "vue";
import p from "./component-library14.js";
import u from "./component-library44.js";
const f = /* @__PURE__ */ n({
  __name: "controls",
  props: {
    hasPlayPause: { type: Boolean },
    value: { type: Boolean },
    pages: { default: void 0 },
    paginationPrev: { default: void 0 },
    paginationNext: { default: void 0 },
    paginationButtonLabelFirst: { default: void 0 },
    paginationButtonLabelLast: { default: void 0 },
    paginationButtonLabel: { default: void 0 },
    paginationAriaLabel: { default: void 0 },
    playPauseAriaLabel: { default: "Animation" },
    infinityScroll: { type: Boolean },
    hidePages: { type: Boolean },
    primary: { type: Boolean },
    secondary: { type: Boolean },
    hidePagesMobile: { type: Boolean },
    doNotScrollIntoView: { type: Boolean }
  },
  emits: ["update", "input"],
  setup(o) {
    const a = o, e = i(a.value);
    return l(
      () => a.value,
      (t) => {
        e.value = t;
      }
    ), { __sfc: !0, props: a, internalIsPlaying: e, PlayPauseButton: p, CarouselNavigation: u };
  }
});
export {
  f as default
};
